import {
  CUIDARI_ACCESS_GATE_COPY,
  type AccessGateNotice,
  type AccessGatePath,
} from '@francisquiniai/cuidari-core/auth'
import { icon } from './shared'

export function AccessPathCard({
  path,
  tone,
  onClick,
  testId,
}: {
  path: AccessGatePath
  tone: 'primary' | 'secondary'
  onClick: () => void
  testId?: string
}) {
  return (
    <button
      type="button"
      className={`login-path login-path--${tone}`}
      onClick={onClick}
      data-testid={testId}
    >
      <span className="login-path__icon">{icon(path.icon)}</span>
      <span className="login-path__copy">
        <strong>{path.title}</strong>
        <span>{path.body}</span>
        {path.scarcity && <em>{icon('schedule')} {path.scarcity}</em>}
      </span>
      <span className="login-path__chevron">{icon('chevron_right')}</span>
    </button>
  )
}

export function SecondaryPathButton({
  path,
  onClick,
  testId,
}: {
  path: AccessGatePath
  onClick: () => void
  testId?: string
}) {
  return (
    <button
      type="button"
      className={`login-secondary login-secondary--${path.accent}`}
      onClick={onClick}
      data-testid={testId}
    >
      <span className="login-secondary__icon">{icon(path.icon)}</span>
      <span>
        <strong>{path.title}</strong>
        <small>{path.helper ?? path.body}</small>
      </span>
    </button>
  )
}

export function GateNoticeCard({
  notice,
  testId,
}: {
  notice: AccessGateNotice
  testId?: string
}) {
  const iconName =
    notice.tone === 'success'
      ? 'check'
      : notice.tone === 'danger'
        ? 'error'
        : 'info'
  return (
    <div
      className={`login-notice login-notice--${notice.tone}`}
      role={notice.tone === 'danger' ? 'alert' : 'status'}
      data-testid={testId}
    >
      <span className="login-notice__icon">{icon(iconName)}</span>
      <span className="login-notice__copy">
        <strong>{notice.title}</strong>
        <span>{notice.body}</span>
        {notice.detail && <em>{notice.detail}</em>}
      </span>
    </div>
  )
}

export function GatePrimaryButton({
  children,
  busy,
  disabled,
  testId,
}: {
  children: string
  busy?: boolean
  disabled?: boolean
  testId?: string
}) {
  return (
    <button
      type="submit"
      className="login-button login-button--primary"
      disabled={busy || disabled}
      data-testid={testId}
    >
      {busy && <span className="login-spinner" aria-hidden="true" />}
      <span>{children}</span>
    </button>
  )
}

export function GateBackButton({
  children = CUIDARI_ACCESS_GATE_COPY.backLabel,
  onClick,
}: {
  children?: string
  onClick: () => void
}) {
  return (
    <button type="button" className="login-button login-button--ghost" onClick={onClick}>
      {icon('arrow_back')}
      <span>{children}</span>
    </button>
  )
}
